import { useEffect, useState } from 'react';
import { browserTimeZone, todayIn, type ISODate } from '../../shared/dates';

export function localToday(): ISODate {
  return todayIn(browserTimeZone());
}

export function localHour(): number {
  return new Date().getHours();
}

/** Today's local date; re-renders when the date rolls over (checked every minute and on focus). */
export function useToday(): ISODate {
  const [today, setToday] = useState(localToday);
  useEffect(() => {
    const check = () => setToday((prev) => {
      const now = localToday();
      return now === prev ? prev : now;
    });
    const id = window.setInterval(check, 60_000);
    window.addEventListener('focus', check);
    return () => {
      window.clearInterval(id);
      window.removeEventListener('focus', check);
    };
  }, []);
  return today;
}
